import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { CLICKHOUSE } from "../../Constants"

function ZdqClickHouseConnector() {
    return <ZdqConnectorSetup vendor={CLICKHOUSE}></ZdqConnectorSetup>
}

export default ZdqClickHouseConnector 